/**
 * Convert USD amount to SECH tokens
 */
export function convertUsdToSech(usdAmount: number, sechPrice: number): number {
  if (sechPrice <= 0) return 0;
  return parseFloat((usdAmount / sechPrice).toFixed(8));
}

/**
 * Convert SECH tokens to USD amount
 */
export function convertSechToUsd(sechAmount: number, sechPrice: number): number {
  return sechAmount * sechPrice;
}

/**
 * Format SECH amount with proper decimal and thousands separators
 */
export function formatSechAmount(amount: number, decimals: number = 4): string {
  return amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: decimals
  });
}

/**
 * Format USD amount with proper currency formatting
 */
export function formatUsdAmount(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

/**
 * Validate if SECH amount is sufficient for purchase
 */
export function hasSufficientSech(requiredAmount: number, availableAmount: number): boolean {
  return availableAmount >= requiredAmount;
}
